(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-link-row"] && !Shopify.designMode) return;
  try {
    
  class AnchorLinksRow extends HTMLElement {
    constructor() {
      super();
      this.pageSectionIds = Array.from(document.querySelectorAll('[data-page-section-id]')).map((section) =>
        section.getAttribute('data-page-section-id')
      );
      this.anchorListItems = this.querySelectorAll('[data-anchor-ref]');
      this.observedSections = document.querySelectorAll('[data-page-section-id]');
    }

    connectedCallback() {
      this.setScrollOffset();
      this.filterAnchorLinks();
      this.addClickEventToAnchors();
      this.observeSections();
    }

    setScrollOffset() {
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      const updateOffset = () => {
        this.scrollOffset = mobileQuery.matches ? 85 : 100;
      };

      updateOffset(); // Set it once initially
      mobileQuery.addEventListener('change', updateOffset); // React to breakpoint change
    }

    filterAnchorLinks() {
      this.anchorListItems.forEach((anchor) => {
        const anchorRef = anchor.getAttribute('data-anchor-ref');
        if (!this.pageSectionIds.includes(anchorRef)) {
          anchor.style.display = 'none'; // Hide the anchor if no matching section ID is found
        }
      });
    }

    addClickEventToAnchors() {
      this.querySelectorAll('.anchor-link').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
          event.preventDefault();

          const targetId = anchor.getAttribute('href')?.substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - this.scrollOffset;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth',
            });
          }
        });
      });
    }

    updateActiveAnchor(activeId) {
      let hasActive = false;

      this.querySelectorAll('.anchor-link').forEach((link) => {
        const linkHref = link.getAttribute('href')?.substring(1); // remove #
        const isActive = linkHref === activeId;

        link.classList.toggle('active', isActive);
        if (isActive) hasActive = true;
      });

      this.classList.toggle('has-active-element', hasActive);
    }

    observeSections() {
      const options = {
        root: null,
        rootMargin: '0px 0px -30% 0px',
        threshold: 0,
      };

      const visibleSections = new Map(); // Track visibility status
      let visibilityTimeout;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute('data-page-section-id');

          if (entry.isIntersecting) {
            visibleSections.set(id, entry.boundingClientRect.top);
          } else {
            visibleSections.delete(id);
          }
        });

        clearTimeout(visibilityTimeout);
        visibilityTimeout = setTimeout(() => {
          if (visibleSections.size === 0) {
            this.updateActiveAnchor(null);
            return;
          }

          // Find the topmost visible section
          const [closestId] = [...visibleSections.entries()].sort((a, b) => a[1] - b[1])[0];
          this.updateActiveAnchor(closestId);
        }, 100); // Small delay prevents flicker
      }, options);

      this.observedSections.forEach((section) => observer.observe(section));
    }
  }

  customElements.define('section-anchors-component', AnchorLinksRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 989px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      const stickyHeader = this.header.querySelector('.header-wrapper');
      if (stickyHeader) {
        document.documentElement.style.setProperty('--header-sticky-height', `${stickyHeader.offsetHeight}px`);
      }
    }

    setReducedHeaderHeight() {
      const stickyHeader = this.header.querySelector('.header-wrapper');
      if (stickyHeader) {
        const reducedHeight = stickyHeader.offsetHeight;
        document.documentElement.style.setProperty('--header-sticky-height-reduced', `${reducedHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.header.classList.add('bg-white');
        return;
      } else {
        this.header.classList.remove('bg-white');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setReducedHeaderHeight();
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setReducedHeaderHeight(); 
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        const megaMenu = document.querySelector('.mega-menu');

        if (megaMenu && megaMenu.hasAttribute('open')) {
          megaMenu.removeAttribute('open');
        }
        this.header.classList.remove('scrolled-past-header');
        this.setHeaderHeight();
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      // this.disclosures.forEach(disclosure => disclosure.close());
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        } else {
          // console.error('close() method not available on disclosure:', disclosure);
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-quote"] && !Shopify.designMode) return;
  try {
    
  class QuoteTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.quote-tab');
      this.tabContents = this.querySelectorAll('.quote-tab-content');
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => this.onTabClick(event));
      });

      this.activateTab(this.tabs[0]);
    }

    onTabClick(event) {
      const clickedTab = event.currentTarget;

      this.activateTab(clickedTab);
    }

    activateTab(tab) {
      // Deactivate all tabs and hide all content panels
      this.tabs.forEach((tab) => {
        tab.classList.remove('active');
        tab.setAttribute('aria-selected', 'false');
      });
      this.tabContents.forEach((content) => {
        content.classList.remove('active');
        content.setAttribute('hidden', true);
      });

      // Activate the selected tab and show its corresponding content
      if (!tab) return;
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      const targetId = tab.getAttribute('data-target');

      const content = this.querySelector(`#${targetId}`);

      if (content) {
        content.classList.add('active');
        content.removeAttribute('hidden');
      }
    }
  }

  customElements.define('quote-tabs', QuoteTabs);

  } catch(e) { console.error(e); }
})();
})();
